// Base paths
export const PHP_V13_URL = process.env.REACT_APP_PHP_V13;
const version = process.env.REACT_APP_VERSION_API;
const endpoint = process.env.REACT_APP_ENDPOINT_API;
const prefix = process.env.REACT_APP_PREFIX_API;

// Main paths
const BaseUrl = `${PHP_V13_URL}/${prefix}/${version}`;

const InterviewURL = `${PHP_V13_URL}/${endpoint}/schedule/${version}/interview`;

/**
 * Constructed paths object
 */
// eslint-disable-next-line import/no-anonymous-default-export
export default {
    // Common URLs, to perform various requests
    common: {
        media: `${BaseUrl}/media`,
        // Authenticated proxy used to fetch stored files, it must always be
        // requested through axios so the Authorization header is attached.
        download: `${PHP_V13_URL}/${prefix}/download`,
    },

    /**
   * Overview URLs
   */
    overview: {
        interviews: `${InterviewURL}`,
    },

};
